import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
    RETRIEVE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
    RETRIEVESINGLE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
    UPDATE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
    DELETE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
} from "./type";
import ARCServerEmployeeWorkDays from "../service/arcServerEmployeeWorkDays";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCServerEmployeeWorkDays.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCServerEmployeeWorkDays.create(data);
        dispatch({
            type: CREATE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCServerEmployeeWorkDays.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCServerEmployeeWorkDays.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCServerEmployeeWorkDays.update(data);
        dispatch({
            type: UPDATE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCServerEmployeeWorkDays.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCServerEmployeeWorkDays.trash(data);
        dispatch({
            type: DELETE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};